import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          gap: "16px",
          padding: "24px",
          fontFamily: "var(--font-family, sans-serif)",
          textAlign: "center",
        }}>
          <span style={{ fontSize: "48px" }}>⚠️</span>
          <h2 style={{ margin: 0, fontSize: "20px", color: "#0f1111" }}>
            Something went wrong
          </h2>
          <p style={{ margin: 0, fontSize: "14px", color: "#565959", maxWidth: "400px" }}>
            {this.state.error?.message || "An unexpected error occurred."}
          </p>
          <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
            <button
              onClick={this.handleReset}
              style={{
                padding: "10px 20px",
                fontSize: "13px",
                fontWeight: 600,
                background: "#ff9900",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Try Again
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: "10px 20px",
                fontSize: "13px",
                fontWeight: 600,
                background: "transparent",
                color: "#565959",
                border: "1px solid #d5d9d9",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
